/* Swarna Ahar — collection/product grid match homepage without touching Ella image layout */
(function () {
  'use strict';

  if (window.__swarnaBestsellerGridInitV4) return;
  window.__swarnaBestsellerGridInitV4 = true;

  var STYLE_ID = 'swarna-bestseller-grid-style-v4';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      /* Card shell only — product image structure is intentionally untouched */
      .productListing.productGrid > .product {
        padding-top: 0 !important;
        padding-bottom: 10px !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card {
        height: 100% !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card > .card {
        width: 100% !important;
        height: 100% !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        display: flex !important;
        flex-direction: column !important;
        overflow: hidden !important;
        background: #fff !important;
        border: 1px solid #e6e1d6 !important;
        border-radius: 13px !important;
        box-shadow: 0 2px 10px rgba(45,57,35,.035) !important;
        transform: none !important;
      }

      /* IMPORTANT: no position/height/padding overrides on card-media, media, adaptive_height or img */
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-quickview {
        display: none !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-information {
        width: 100% !important;
        flex: 1 1 auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 11px 12px 13px !important;
        display: flex !important;
        flex-direction: column !important;
        background: #fff !important;
        font-family: "Montserrat", Arial, Helvetica, sans-serif !important;
        text-align: left !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-information__wrapper,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper-title-vendor {
        width: 100% !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        text-align: left !important;
        background: transparent !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-title,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-title .text {
        font-family: "Montserrat", Arial, Helvetica, sans-serif !important;
        font-size: 13px !important;
        line-height: 19px !important;
        font-weight: 600 !important;
        font-style: normal !important;
        letter-spacing: 0 !important;
        text-transform: none !important;
        text-decoration: none !important;
        color: #242720 !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-title {
        width: 100% !important;
        height: 38px !important;
        min-height: 38px !important;
        max-height: 38px !important;
        margin: 0 0 6px !important;
        padding: 0 !important;
        display: -webkit-box !important;
        -webkit-box-orient: vertical !important;
        -webkit-line-clamp: 2 !important;
        overflow: hidden !important;
        text-align: left !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-title:hover,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-title:hover .text {
        color: #11863f !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-summary,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-positive_vibes,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-swatch,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .unit-price {
        display: none !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-price {
        width: 100% !important;
        min-height: 21px !important;
        margin: 0 0 8px !important;
        padding: 0 !important;
        display: block !important;
        text-align: left !important;
        background: transparent !important;
        font-family: "Montserrat", Arial, Helvetica, sans-serif !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-price .price,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-price dl {
        width: 100% !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        text-align: left !important;
        justify-content: flex-start !important;
        font-family: "Montserrat", Arial, Helvetica, sans-serif !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price:not(.price--on-sale) .price__regular {
        width: 100% !important;
        display: flex !important;
        align-items: baseline !important;
        justify-content: flex-start !important;
        gap: 7px !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price:not(.price--on-sale) .price__sale,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price.price--on-sale .price__regular {
        display: none !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price.price--on-sale .price__sale {
        width: 100% !important;
        display: flex !important;
        flex-wrap: wrap !important;
        align-items: baseline !important;
        justify-content: flex-start !important;
        gap: 7px !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__regular dd,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__sale dd,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__last,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__compare {
        margin: 0 !important;
        padding: 0 !important;
        min-height: 0 !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__sale .price__last { order: 1 !important; }
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__sale .price__compare { order: 2 !important; }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-price .price-item,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-price .money {
        font-family: "Montserrat", Arial, Helvetica, sans-serif !important;
        letter-spacing: 0 !important;
        text-transform: none !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__last .price-item,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__last .money,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__regular .price__last .price-item,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__regular .price__last .money {
        color: #20211d !important;
        font-size: 15px !important;
        line-height: 1.25 !important;
        font-weight: 700 !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__compare .price-item,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__compare .money,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__compare s,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__compare del {
        color: #87877f !important;
        font-size: 10px !important;
        line-height: 1.25 !important;
        font-weight: 500 !important;
        text-decoration-thickness: 1px !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__saved,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__label_sale {
        display: none !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card {
        width: 100% !important;
        margin: auto 0 0 !important;
        padding: 0 !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;
        gap: 6px !important;
        background: transparent !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .card-action {
        position: static !important;
        width: 100% !important;
        max-width: none !important;
        margin: 0 !important;
        padding: 0 !important;
        opacity: 1 !important;
        visibility: visible !important;
        pointer-events: auto !important;
        transform: none !important;
        box-shadow: none !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card form,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .variants {
        width: 100% !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .button,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .button-ATC,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .product-form__submit,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .swarna-grid-buy-now {
        appearance: none !important;
        -webkit-appearance: none !important;
        position: relative !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: none !important;
        height: 34px !important;
        min-height: 34px !important;
        max-height: 34px !important;
        margin: 0 !important;
        padding: 0 10px !important;
        border-radius: 999px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        font-family: "Montserrat", Arial, Helvetica, sans-serif !important;
        font-size: 11px !important;
        line-height: 1 !important;
        font-weight: 600 !important;
        font-style: normal !important;
        letter-spacing: 0 !important;
        text-transform: none !important;
        text-align: center !important;
        white-space: nowrap !important;
        text-decoration: none !important;
        box-shadow: none !important;
        cursor: pointer !important;
        transform: none !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .button span,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .button-ATC span,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .product-form__submit span {
        font: inherit !important;
        line-height: 1 !important;
        letter-spacing: 0 !important;
        text-transform: none !important;
        color: inherit !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .button,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .button-ATC,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .product-form__submit {
        color: #fff !important;
        background: #11863f !important;
        border: 1px solid #11863f !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .swarna-grid-buy-now {
        color: #176f39 !important;
        background: #fff !important;
        border: 1px solid #9eb6a5 !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .button:hover,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .button-ATC:hover,
      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .product-form__submit:hover {
        color: #fff !important;
        background: #0b7335 !important;
        border-color: #0b7335 !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .swarna-grid-buy-now:hover {
        color: #11863f !important;
        background: #f8fcf9 !important;
        border-color: #11863f !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .swarna-grid-buy-now[disabled] {
        opacity: .5 !important;
        cursor: not-allowed !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .swarna-grid-buy-now.is-loading {
        color: transparent !important;
        pointer-events: none !important;
      }

      body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .swarna-grid-buy-now.is-loading::after {
        content: '' !important;
        position: absolute !important;
        left: 50% !important;
        top: 50% !important;
        width: 14px !important;
        height: 14px !important;
        margin: -7px 0 0 -7px !important;
        border: 2px solid rgba(17,134,63,.22) !important;
        border-top-color: #11863f !important;
        border-radius: 50% !important;
        animation: swarnaGridSpin .65s linear infinite !important;
      }

      @keyframes swarnaGridSpin { to { transform: rotate(360deg); } }

      @media (min-width: 901px) {
        body.product-card-layout-02 .productListing.productGrid {
          margin-left: -7px !important;
          margin-right: -7px !important;
        }
        body.product-card-layout-02 .productListing.productGrid > .product {
          padding-left: 7px !important;
          padding-right: 7px !important;
        }
      }

      @media (max-width: 900px) {
        body.product-card-layout-02 .productListing.productGrid {
          margin-left: -5px !important;
          margin-right: -5px !important;
          --space-between-horiz-mb: 10px !important;
          --space-between-vert-mb: 10px !important;
        }

        body.product-card-layout-02 .productListing.productGrid > .product {
          padding-left: 5px !important;
          padding-right: 5px !important;
          padding-bottom: 10px !important;
        }

        body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-information {
          padding: 10px 9px 10px !important;
        }

        body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-title,
        body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-title .text {
          font-size: 12px !important;
          line-height: 18px !important;
          font-weight: 600 !important;
        }

        body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .card-title {
          height: 36px !important;
          min-height: 36px !important;
          max-height: 36px !important;
          margin-bottom: 6px !important;
        }

        body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__last .price-item,
        body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__last .money,
        body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__regular .price__last .price-item,
        body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .price__regular .price__last .money {
          font-size: 15px !important;
          font-weight: 700 !important;
        }

        body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .button,
        body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .button-ATC,
        body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .wrapper__card .product-form__submit,
        body.product-card-layout-02 .productListing.productGrid .swarna-bestseller-grid-card .swarna-grid-buy-now {
          height: 34px !important;
          min-height: 34px !important;
          max-height: 34px !important;
          padding-left: 8px !important;
          padding-right: 8px !important;
          font-size: 10px !important;
          font-weight: 600 !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function belongsToGrid(item) {
    if (!item || !item.closest) return false;
    var listing = item.closest('.productListing');
    if (listing) return listing.classList.contains('productGrid') && !listing.classList.contains('productList');
    return !!item.closest('.productGrid, .product-grid, .products-grid, [data-product-grid]');
  }

  function getProductData(item) {
    try { return JSON.parse(item.getAttribute('data-json-product') || '{}'); }
    catch (e) { return {}; }
  }

  function productUrl(item) {
    var link = item.querySelector('.card-title[href], .card-link[href], .card-media a[href]');
    return link ? link.href : '#';
  }

  function findVariantId(item, data) {
    var selectedInput = item.querySelector('.wrapper__card form.variants input[name="id"], form.variants input[name="id"]');
    if (selectedInput && selectedInput.value) return selectedInput.value;
    if (data && Array.isArray(data.variants)) {
      var available = data.variants.find(function (variant) { return variant && variant.available !== false; });
      if (available && available.id) return available.id;
      if (data.variants[0] && data.variants[0].id) return data.variants[0].id;
    }
    return '';
  }

  function normalizeAddToCartText(item) {
    item.querySelectorAll('.wrapper__card .button, .wrapper__card .button-ATC, .wrapper__card .product-form__submit').forEach(function (button) {
      var text = (button.textContent || '').trim().toLowerCase();
      if (text.indexOf('add to cart') !== -1) {
        var span = button.querySelector('span');
        if (span) span.textContent = 'Add to Cart';
        else button.textContent = 'Add to Cart';
      }
    });
  }

  function addBuyNow(item) {
    if (item.querySelector('.swarna-grid-buy-now')) return;
    var actions = item.querySelector('.wrapper__card');
    if (!actions) return;

    var data = getProductData(item);
    var variants = data && Array.isArray(data.variants) ? data.variants : [];
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'swarna-grid-buy-now';
    button.textContent = 'Buy Now';
    button.setAttribute('aria-label', 'Buy now');

    if (variants.length && !variants.some(function (variant) { return variant && variant.available !== false; })) {
      button.disabled = true;
    }

    button.addEventListener('click', function () {
      if (button.disabled || button.classList.contains('is-loading')) return;
      if (variants.length > 1) {
        window.location.href = productUrl(item);
        return;
      }

      var variantId = findVariantId(item, data);
      if (!variantId) {
        window.location.href = productUrl(item);
        return;
      }

      button.classList.add('is-loading');
      button.disabled = true;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add product');
        return response.json();
      })
      .then(function () { window.location.href = root + 'checkout'; })
      .catch(function () {
        button.classList.remove('is-loading');
        button.disabled = false;
        window.location.href = productUrl(item);
      });
    });

    actions.appendChild(button);
  }

  function decorate(item) {
    if (!belongsToGrid(item)) return;
    item.classList.add('swarna-bestseller-grid-card');
    normalizeAddToCartText(item);
    addBuyNow(item);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('.product-item')) decorate(scope);
    scope.querySelectorAll('.product-item').forEach(decorate);
  }

  function init() {
    injectStyles();
    scan(document);
    if (!document.body || !window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node && node.nodeType === 1) scan(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
